import React from 'react';
import ImageIcon from '@/assets/imageIcon.svg';
import FilePdfLight from '@/assets/filePdfLight.svg';
import FileZipLight from '@/assets/file-zip-light.svg';

export function generateHashCode(text: string): number {
  return text.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}

export function getIcon(contentType: string): React.ComponentType<React.SVGProps<SVGSVGElement>> {
  switch (contentType) {
    case 'image/jpeg':
    case 'image/gif':
    case 'image/png':
    case 'image/tiff':
    case 'image/bmp':
    case 'image/webp':
      return ImageIcon;
    case 'video/webm':
    case 'video/x-flv':
    case 'video/mp4':
    case 'video/mpeg':
    case 'application/x-mpegURL':
    case 'video/MP2T':
    case 'video/3gpp':
    case 'video/quicktime':
    case 'video/x-msvideo':
    case 'video/x-ms-wmv':
    case 'video/3gpp2':
    case 'video/ogg':
      return ImageIcon; // Using image icon as fallback for video
    case 'audio/mpeg':
    case 'audio/aac':
    case 'audio/midi':
    case 'audio/x-midi':
    case 'audio/ogg':
    case 'audio/opus':
    case 'audio/wav':
    case 'audio/webm':
    case 'audio/3gpp':
    case 'audio/3gpp2':
      return ImageIcon; // Using image icon as fallback for audio
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.oasis.opendocument.text':
    case 'application/rtf':
      return ImageIcon; // Using image icon as fallback for documents
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return ImageIcon; // Using image icon as fallback for spreadsheets
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return ImageIcon; // Using image icon as fallback for presentations
    case 'application/pdf':
      return FilePdfLight;
    case 'application/zip':
    case 'application/x-7z-compressed':
    case 'application/vnd.rar':
      return FileZipLight;
    case 'text/plain':
      return ImageIcon; // Using image icon as fallback for text files
    case 'text/csv':
      return ImageIcon; // Using image icon as fallback for CSV files
    default:
      return ImageIcon; // Default fallback icon
  }
}
